export default __webpack_public_path__ + "static/media/1077.94bbb80d.png";